import { Grant, GrantContext, GrantResult } from '../types';

export class PlaceholderGrant implements Grant {
  constructor(
    public readonly label: string,
    public readonly value: boolean
  ) {}

  async allowed(_context: GrantContext): Promise<GrantResult> {
    return this.value;
  }
}
